import ProfilesRootScreen from './ProfilesRootScreen';
import AddProfileScreen from './AddProfileScreen';
import ProfileScreen from './ProfileScreen';
import EditProfileScreen from './EditProfileScreen';
import ProfileContactDetailsScreen from './ProfileContactDetailsScreen';
import EmergencyContactCreateScreen from './EmergencyContactCreateScreen';
import EmergencyContactEditScreen from './EmergencyContactEditScreen';
import EmergencyContactListScreen from './EmergencyContactListScreen';
import CareTeamScreen from './CareTeamScreen';
import AddCareTeamScreen from './AddCareTeamScreen';
import CareTeamMemberScreen from './CareTeamMemberScreen';
import EditCareTeamMemberScreen from './EditCareTeamMemberScreen';
import CopyCareTeamMemberScreen from './CopyCareTeamMemberScreen';
import AddRelatedCareTeamMemberScreen from './AddRelatedCareTeamMemberScreen';
import InviteCollaboratorScreen from './InviteCollaboratorScreen';
import InviteDetailsScreen from './InviteDetailsScreen';
import CollaboratorScreen from './CollaboratorScreen';
import AddTransferRequestScreen from './AddTransferRequestScreen';
import TransferRequestScreen from './TransferRequestScreen';
import TransferRequestResponseScreen from './TransferRequestResponseScreen';
import AddCardScreen from './AddCardScreen';
import EditCardScreen from './EditCardScreen';
import DataScreen from './DataScreen';
import DataDetailsScreen from './DataDetailsScreen';
import AddDataScreen from './AddDataScreen';
import EditDataScreen from './EditDataScreen';
import AddPortalScreen from './AddPortalScreen';
import AddFastenPortalScreen from './AddFastenPortalScreen';
import AddTefcaConnectionScreen from './AddTefcaConnectionScreen';
import NoteScreen from './NoteScreen';
import AddNoteScreen from './AddNote';
import EditNoteScreen from './EditNoteScreen';
import TransferNoteScreen from './TransferNote';
import InviteScreen from './InviteScreen';
import PortalConnectionScreen from './PortalConnectionScreen';
import FastenPortalConnectionScreen from './FastenPortalConnectionScreen';
import DataBulkUpdate from './DataBulkUpdate';
import ReportsScreen from './ReportsScreen';
import CopyNoteScreen from './CopyNote';
import SharedReportScreen from './SharedReportScreen';
import AddSharedReportScreen from './AddSharedReportScreen';
import FileScreen from './FileScreen';
import FilesScreen from './FilesScreen';
import ChatScreen from './ChatScreen';
import DateLabsScreen from './DateLabsScreen';
import LabHistoryScreen from './LabHistoryScreen';
import ClientProfileScreen from './ClientProfileScreen';
import EditClientProfileScreen from './EditClientProfileScreen';
import ClientRecordScreen from './ClientRecordScreen';
import AddClientRecordScreen from './AddClientRecordScreen';
import AddClientInvitationScreen from './AddClientInvitationScreen';
import EditClientRecordScreen from './EditClientRecordScreen';
import AddClientRecordInvitationScreen from './AddClientRecordInvitationScreen';
import AddClientRecordNoteScreen from './AddClientRecordNoteScreen';
import ClientRecordNoteDetailsScreen from './ClientRecordNoteDetailsScreen';
import EditClientRecordNoteScreen from './EditClientRecordNoteScreen';
import CopyOrgNotesToClientsScreen from './CopyOrgNotesToClientsScreen';
import CopyOrgCareTeamMemberToClientsScreen from './CopyOrgCareTeamMemberToClientsScreen';
import SendClientsMessageScreen from './SendClientsMessageScreen';
import MessagePreferencesScreen from './MessagePreferencesScreen';
import ClientsActivityScreen from './ClientsActivityScreen';
import ClientActivityDetailsScreen from './ClientActivityDetailsScreen';
import OrgInviteAcceptSuccessScreenTsx from './OrgInviteAcceptSuccessScreen';
import ProfileActivityDetailsScreen from './ProfileActivityDetailsScreen';
import ProfileActivityScreen from './ProfileActivityScreen';
import MessageProfileScreen from './MessageProfileScreen';
import ClientActivityHistoryScreen from './ClientActivityHistoryScreen';
import CopyVisitToClientsScreen from './CopyVisitToClientsScreen';
import AccessScreen from './AccessScreen';
import ConnectScreen from './ConnectScreen';
import ProfileNotesScreen from './ProfileNotesScreen';
import BulkAddClientRecordsScreen from './BulkAddClientRecordsScreen';
import AddProfileSuggestedFoldersScreen from './AddSuggestedProfileFoldersScreen';
import EditClientInvitationScreen from './EditClientInvitationScreen';
import BulkAddClientRecordsProfilesScreen from './BulkAddClientRecordsProfilesScreen';
import EditClientBillingInfoScreen from './EditClientBillingInfoScreen';
import ClientInvoiceItemsScreen from './ClientInvoiceItemsScreen';
import CollaboratorInvoiceScreen from './CollaboratorInvoiceScreen';
import EditLegalDecisionMakerScreen from './EditLegalDecisionMakerScreen';
import EditCodeStatusScreen from './EditCodeStatusScreen';
import BulkInviteClientsScreen from './BulkInviteClientsScreen';
import MessagesScreen from './MessagesScreen';
import SendNoteScreen from './SendNoteScreen';
import VisitInviteEmailsScreen from './VisitInviteEmailsScreens';
import wrapInTabContentContainer from '../../../AppNavigator/TabNavigation/wrapInTabContentContainer';

const screens = {
    ProfilesRootScreen: wrapInTabContentContainer(ProfilesRootScreen),
    AddProfileScreen: wrapInTabContentContainer(AddProfileScreen),
    ProfileScreen: wrapInTabContentContainer(ProfileScreen),
    EditProfileScreen: wrapInTabContentContainer(EditProfileScreen),
    ProfileContactDetailsScreen: wrapInTabContentContainer(ProfileContactDetailsScreen),
    EmergencyContactCreateScreen: wrapInTabContentContainer(EmergencyContactCreateScreen),
    EmergencyContactEditScreen: wrapInTabContentContainer(EmergencyContactEditScreen),
    EmergencyContactListScreen: wrapInTabContentContainer(EmergencyContactListScreen),
    CareTeamScreen: wrapInTabContentContainer(CareTeamScreen),
    AddCareTeamScreen: wrapInTabContentContainer(AddCareTeamScreen),
    CareTeamMemberScreen: wrapInTabContentContainer(CareTeamMemberScreen),
    EditCareTeamMemberScreen: wrapInTabContentContainer(EditCareTeamMemberScreen),
    CopyCareTeamMemberScreen: wrapInTabContentContainer(CopyCareTeamMemberScreen),
    AddRelatedCareTeamMemberScreen: wrapInTabContentContainer(AddRelatedCareTeamMemberScreen),
    InviteCollaboratorScreen: wrapInTabContentContainer(InviteCollaboratorScreen),
    InviteDetailsScreen: wrapInTabContentContainer(InviteDetailsScreen),
    CollaboratorScreen: wrapInTabContentContainer(CollaboratorScreen),
    AddTransferRequestScreen: wrapInTabContentContainer(AddTransferRequestScreen as any),
    TransferRequestScreen: wrapInTabContentContainer(TransferRequestScreen),
    TransferRequestResponseScreen: wrapInTabContentContainer(TransferRequestResponseScreen),
    AddCardScreen: wrapInTabContentContainer(AddCardScreen),
    EditCardScreen: wrapInTabContentContainer(EditCardScreen),
    DataScreen: wrapInTabContentContainer(DataScreen),
    DataDetailsScreen: wrapInTabContentContainer(DataDetailsScreen),
    AddDataScreen: wrapInTabContentContainer(AddDataScreen),
    EditDataScreen: wrapInTabContentContainer(EditDataScreen),
    AddPortalScreen: wrapInTabContentContainer(AddPortalScreen),
    AddFastenPortalScreen: wrapInTabContentContainer(AddFastenPortalScreen),
    AddTefcaConnectionScreen: wrapInTabContentContainer(AddTefcaConnectionScreen),
    NoteScreen: wrapInTabContentContainer(NoteScreen),
    AddNoteScreen: wrapInTabContentContainer(AddNoteScreen),
    EditNoteScreen: wrapInTabContentContainer(EditNoteScreen),
    TransferNoteScreen: wrapInTabContentContainer(TransferNoteScreen),
    InviteScreen: wrapInTabContentContainer(InviteScreen),
    PortalConnectionScreen: wrapInTabContentContainer(PortalConnectionScreen),
    FastenPortalConnectionScreen: wrapInTabContentContainer(FastenPortalConnectionScreen),
    DataBulkUpdate: wrapInTabContentContainer(DataBulkUpdate),
    ReportsScreen: wrapInTabContentContainer(ReportsScreen),
    CopyNoteScreen: wrapInTabContentContainer(CopyNoteScreen),
    SharedReportScreen: wrapInTabContentContainer(SharedReportScreen),
    AddSharedReportScreen: wrapInTabContentContainer(AddSharedReportScreen),
    FileScreen: wrapInTabContentContainer(FileScreen),
    FilesScreen: wrapInTabContentContainer(FilesScreen),
    ChatScreen: wrapInTabContentContainer(ChatScreen),
    DateLabsScreen: wrapInTabContentContainer(DateLabsScreen),
    LabHistoryScreen: wrapInTabContentContainer(LabHistoryScreen),
    ClientProfileScreen: wrapInTabContentContainer(ClientProfileScreen),
    EditClientProfileScreen: wrapInTabContentContainer(EditClientProfileScreen),
    ClientRecordScreen: wrapInTabContentContainer(ClientRecordScreen),
    AddClientRecordScreen: wrapInTabContentContainer(AddClientRecordScreen),
    AddClientInvitationScreen: wrapInTabContentContainer(AddClientInvitationScreen),
    EditClientRecordScreen: wrapInTabContentContainer(EditClientRecordScreen),
    AddClientRecordInvitationScreen: wrapInTabContentContainer(AddClientRecordInvitationScreen),
    AddClientRecordNoteScreen: wrapInTabContentContainer(AddClientRecordNoteScreen),
    ClientRecordNoteDetailsScreen: wrapInTabContentContainer(ClientRecordNoteDetailsScreen),
    EditClientRecordNoteScreen: wrapInTabContentContainer(EditClientRecordNoteScreen),
    CopyOrgNotesToClientsScreen: wrapInTabContentContainer(CopyOrgNotesToClientsScreen),
    CopyOrgCareTeamMemberToClientsScreen: wrapInTabContentContainer(CopyOrgCareTeamMemberToClientsScreen),
    SendClientsMessageScreen: wrapInTabContentContainer(SendClientsMessageScreen),
    MessagePreferencesScreen: wrapInTabContentContainer(MessagePreferencesScreen),
    ClientsActivityScreen: wrapInTabContentContainer(ClientsActivityScreen),
    OrgInviteAcceptSuccessScreen: wrapInTabContentContainer(OrgInviteAcceptSuccessScreenTsx),
    ClientActivityDetailsScreen: wrapInTabContentContainer(ClientActivityDetailsScreen),
    ProfileActivityDetailsScreen: wrapInTabContentContainer(ProfileActivityDetailsScreen),
    ProfileActivityScreen: wrapInTabContentContainer(ProfileActivityScreen),
    MessageProfileScreen: wrapInTabContentContainer(MessageProfileScreen),
    ClientActivityHistoryScreen: wrapInTabContentContainer(ClientActivityHistoryScreen),
    CopyVisitToClientsScreen: wrapInTabContentContainer(CopyVisitToClientsScreen),
    AccessScreen: wrapInTabContentContainer(AccessScreen),
    ConnectScreen: wrapInTabContentContainer(ConnectScreen),
    ProfileNotesScreen: wrapInTabContentContainer(ProfileNotesScreen),
    BulkAddClientRecordsScreen: wrapInTabContentContainer(BulkAddClientRecordsScreen),
    AddProfileSuggestedFoldersScreen: wrapInTabContentContainer(AddProfileSuggestedFoldersScreen),
    EditClientInvitationScreen: wrapInTabContentContainer(EditClientInvitationScreen),
    BulkAddClientRecordsProfilesScreen: wrapInTabContentContainer(BulkAddClientRecordsProfilesScreen),
    EditClientBillingInfoScreen: wrapInTabContentContainer(EditClientBillingInfoScreen),
    ClientInvoiceItemsScreen: wrapInTabContentContainer(ClientInvoiceItemsScreen),
    CollaboratorInvoiceScreen: wrapInTabContentContainer(CollaboratorInvoiceScreen),
    EditLegalDecisionMakerScreen: wrapInTabContentContainer(EditLegalDecisionMakerScreen),
    EditCodeStatusScreen: wrapInTabContentContainer(EditCodeStatusScreen),
    BulkInviteClientsScreen: wrapInTabContentContainer(BulkInviteClientsScreen),
    MessagesScreen: wrapInTabContentContainer(MessagesScreen),
    SendNoteScreen: wrapInTabContentContainer(SendNoteScreen),
    VisitInviteEmailsScreen: wrapInTabContentContainer(VisitInviteEmailsScreen),
};

export { screens };
